import { Component } from "react"

export default class extends Component {
    constructor(props, context) {
        super(props, context);

        this.getChartFillPercentage = this.getChartFillPercentage.bind(this);
        this.getPipeLevelPercentage = this.getPipeLevelPercentage.bind(this);
        this.getPipeLevelStatus = this.getPipeLevelStatus.bind(this);
    }

    getPipeLevelPercentage(pipeDiameter, pipeVal){
        return ((pipeVal / pipeDiameter )* 100).toFixed(0);
    }

    getChartFillPercentage(pipeDiameter, pipeVal){

        let pipeLevelPercentage = this.getPipeLevelPercentage(pipeDiameter, pipeVal);
        let circleMaskMaxHeight = 84;
        return ( circleMaskMaxHeight - (( pipeLevelPercentage * circleMaskMaxHeight) / 100 ) );
    }

    getPipeLevelStatus( pipeDiameter, pipeLevelCurrentVal, rangeMedium, rangeHigh){
        let percent = this.getPipeLevelPercentage(pipeDiameter, pipeLevelCurrentVal);
        if(percent >= rangeHigh)
        {
            return 1;
        }
        else if( percent >= rangeMedium)
        {
            return 2;
        }
        else {
            return 3;
        }
    }

    render(){

        const { pipeLevelDiameter,
                pipeLevelWarningRangeMedium,
                pipeLevelWarningRangeHigh,
                pipeLevelCurrentVal } = this.props;

        return(
            <div className={"overflow-status-" + this.getPipeLevelStatus(pipeLevelDiameter,pipeLevelCurrentVal, pipeLevelWarningRangeMedium, pipeLevelWarningRangeHigh)}>

                <div className="circle-chart">
                    <div className="chart-left">
                        <svg width="100%" height="70" viewBox="0 0 84 84">
                            <defs>
                                <mask id="mask" x="0" y="0">
                                    <circle cx="42" cy="42" r="40" style={{fill: "#fff"}}/>
                                </mask>
                            </defs>
                            <circle cx="42" cy="42" r="40.5" style={{ fill: "#f1f2f3", stroke: "#c1c2c3", strokeWidth: 1}} />
                            <rect id="circle-chart-fill" x="0" y={ this.getChartFillPercentage( pipeLevelDiameter, pipeLevelCurrentVal)} width="84" height="84" style={{ mask: "url(#mask)", transition: "all 1s", strokeWidth: 2 }} />
                        </svg>
                    </div>
                    <div className="chart-right">
                        <span className="chart-value">{ this.getPipeLevelPercentage( pipeLevelDiameter, pipeLevelCurrentVal) }%</span>
                    </div>
                </div>
                <div className="circle-chart-title mb-2">Current Level: <strong>{ pipeLevelCurrentVal }mm</strong></div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/site/pipeLevel/pipeLevel-component.js